export default {
  lang: '中文',
  homeScreen: {
    title: '助您圆梦',
    stayConnected: '保持跟进：',
    download: '现在就下载',
  },
  notification: {
    newAndNow: '最新消息！',
    alert: '警报',
    message: '消息',
    contest: '竞赛',
    badge: '新徽章',
    'content-update': '内容更新',
    events: '活动',
  },
  loginScreen: {
    version2: {
      homeTitle: '让我们看看能否在系统中找到您的现有资料。',
      homeTitleSub: '输入您通常用于登录培训计划的电子邮件地址。',
      noAccount: '未找到帐户 ({email})，请尝试使用其他电子邮件或立即创建帐户。',
      continueButton: '继续',
      success: '成功更新您的账户！您将很快被重定向到主页。',
      successNewAccount: '完成注册后，您将收到一封确认电子邮件来验证您的帐户。',
      loginButton: '登录',
      matchFound: '我们已找到匹配对象，请填写密码以继续。',
      magicLink: '通过电子邮件中的链接登录：',
      magicLinkButton: '申请 Magic Link',
      magicLinkTitle: '向您的电子邮件发送直接链接，让您立即登录。',
      otherEmailButton: '提交',
      title:
        '请花一点时间填写以下所有信息，因为这些信息将填充您的个人资料和联系信息。',
      titleIndustry:
        '请花一点时间填写以下所有信息，因为这些信息将填充您的个人资料和联系信息。',
      register: '创建账户',
      agent: '旅游顾问',
      visitor: '行业访客',
      step1: '步骤 1：用户类型',
      step2: '步骤 2：创建账户',
      step3: '步骤 3：创建个人资料',
      marketingOptIn: '您确定没有兴趣与该计划的旅游贸易团队保持联系？',
      optIn: '是的，我感兴趣',
      optOut: '不感兴趣',
      step2Sub1: '介绍自己',
      step2Sub2: '向我们介绍您的企业',
      privacyHead: '通信偏好',
      privacySub:
        '勾选以下复选框，以确保您收到来自供应商旅游贸易团队的重要通信（产品更新和公告、奖励、激励措施、FAM 等），以及来自 TravPRO Mobile 的旅游贸易网络和销售支持计划。',
      privacy: '我们保护您的隐私，绝不出售、滥用或辜负您的信任。',
      store: '在应用程序商店轻松下载该程序：',
      powered: '由',
      toastMessage: {
        forgotSuccess:
          '我们已通过电子邮件向您发送了密码重置链接！您将在 10 秒后被重定向到登录页面。',
        emailNotExisting: '您输入的电子邮件地址不存在。',
        magicLinkMessage: '请稍候，我们正在为您注册。',
        magicLinkError:
          '我们无法在数据库中找到您的帐户，请手动登录。您将在 10 秒后重新定向。',
        magicLinkError1:
          '我们找不到有效的令牌，请登录或申请新的魔法链接。如果问题仍然存在，请联系我们： info@travpromobile.com。',
        magicLinkError2:
          '我们无法在数据库中找到您的帐户，请手动登录。您将在 10 秒后重新定向。',
        magicLinkSuccess:
          '通过 {email} 查看您的电子邮件。里面有一个神奇的链接，可以让你登录。',
        magicLinkErrorWait: '请在两次魔法链接请求之间等待 5 分钟。',
        emailNotFoundError:
          '我们的记录中找不到您输入的电子邮件地址。请检查是否有拼写错误或创建一个账户。',
      },
      errors: {
        zipCodeNotFound: '未找到邮编，请重试',
        zipCodeOnlyNumbers: '邮编只能包含数字',
        password: '请输入密码',
        passwordNotMatching: '您输入的密码不匹配',
        passwordTooShort: '密码至少需要 8 个字符',
        emailExists:
          '该电子邮件地址已存在或无效。请尝试使用其他电子邮件地址或登录您的帐户。',
        fillInAllFields: '请填写所有必填项',
        fillInEmail: '请填写您的电子邮件。',
        emailNotExisting: '您输入的电子邮件地址不存在。',
      },
      fields: {
        forgotSubCopy: '忘记密码并想更改？',
        forgotSubCopy2:
          '想要完全绕过密码？我们将向您发送一封电子邮件，其中包含一个神奇的链接，可以自动登录程序。',
        city: '城市',
        companyName: '公司名称',
        role: '您的角色',
        description: '哪项最能描述贵公司的业务？',
        country: '国家',
        password: '密码',
        passwordRegister: '选择密码（最少 8 个字符）',
        passwordConfirm: '确认密码',
        firstName: '姓（名）',
        lastName: '姓（家族）',
        agency: '您的机构名称',
        title: '您的角色（请选择一个）',
        company: '公司名称',
        select: '选择以下选项',
        state: '国家',
        province: '省/地区/州',
        zipCode: '邮政编码',
        postalCode: '邮政编码',
        affiliate: '您的主要机构隶属于哪个团体？',
        hostAgency: '您的主办机构？',
        executive: '行政部门',
        management: '管理层',
        marketing: '市场营销',
        sales: '销售',
        coordinator: '协调员',
        opt: '与本计划的旅游贸易团队保持联系并接收最新信息。',
        optMarketing: '就类似计划和活动与 TravPRO 保持联系。',
        retail: '零售店面',
        home: '家庭代理',
        independent: '独立承包商',
        host: '主办机构',
        call: '呼叫中心或网络机构',
        other: '其他',
        describes: '什么最能描述您和贵机构的业务？',
      },
    },
    title: '旅游专员培训以及销售支持计划',
    welcome: {
      headerTop: '欢迎访问',
      headerBottom: '加州旅游梦之星销售伙伴。 ',
    },
    sellingPoints: [
      '日常销售转化资源',
      '高影响力的发现和推介',
      '通过‘收藏夹’实现个性化',
      '在线、离线 – 随时、随地',
      '分享、连接、转化',
    ],
    emailPrompt: '请输入您的电邮地址，以确认您是旅游专员。',
    tAndC: {
      agree: '继续即代表您同意我们的 ',
      privacyPolicy: '隐私政策',
      and: ' 以及 ',
      termsConditions: '条款和条件',
    },
    fields: {
      agency: '机构',
      email: '电子邮箱',
      firstName: '名字',
      lastName: '姓氏',
      agencyName: '机构名称',
      stateProvince: '所在州/省',
      registrationCode: '促销代码（可选）',
      required: '必填',
      invalidEmail: '无效的电邮地址',
      opt: '保持联系！ 是的，我想选择“访问加利福尼亚”的通讯方式，让我随时了解新闻，事件，奖励措施，FAM等信息！',
      forgot:
        '忘记密码？点击下面的按钮，我们将向您发送一封电子邮件来重置密码。',
    },
    forgot: '重置密码',
    noAgent: {
      noAgentButton: '我不是顾问',
      title: '感谢您对加州梦之星感兴趣。',
      messageWeb:
        '本网站上的内容专供旅游专员阅读。 \n 如想了解有关加州梦之星的更多信息，请访问： ',
      messageMobile:
        '本 App 上的部分内容专供旅游专员阅读，但您也可以随心按下‘继续’按钮，以浏览有关本 App 内容的预览。',
      continue: '继续',
      visitWebsite: '访问网站 >',
    },
    newUser: '新用户',
    register: '注册',
  },
  welcomeScreen: {
    title: '欢迎访问\n加州梦之星培训计划以及销售伙伴',
    helloUser: '您好 {name}',
    hello: '您好，',
    fromAgency: '来自  {agency}',
    notUser: '不是 {name}？',
    introOnline: '立即在线开启培训之旅，或者，先预加载内容，以便线下随时使用！',
    introOffline: '您已预加载最新版本。随时随地开始培训或销售！',
    startTraining: '开始培训',
    downloader: {
      preload: '预加载',
      stop: '停止',
      init: '初始化中……',
      lastUpdate: '最近更新： ',
    },
  },
  trainingScreens: {
    review: '复习',
    start: '开始',
    continue: '继续',
    tip: '提示',
    specialization: '专业化模块',
    welcome:
      '欢迎来到我们重新设计的培训部分。 只需完成模块即可获得实现成为金牌CA STAR最终目标的积分！ 右侧的栏会向您确切显示您的工作状况',
    restart: '重新开始',
    durationInMinutes: '{number} 分钟',
    percentageComplete: '已完成 {number}%',
    unlock: '完成培训章节 {number}，以解锁此章节。',
    unlockSpecialization: '完成基础课程以解锁本章节',
    unlockSubtitle: '完成几个培训章节，以解锁更多章节。',
    allUnlocked: '您已解锁全部章节！',
    certificate: '证书',
    courseComplete: '课程已完成！',
    chapterComplete: 'Chapter complete!',
    message: '{count} STAR Message',
    endReached: '您已到达底部',
    retainEnd: '使用顶部应用栏导航本章节，或按下后退键，返回概览部分。',
    watchListenRead: '观看、聆听和阅读更多内容',
    trouble: '看起来您遇到困难了，您是否想要跳过这一题？',
    confirm: '确认您的答案',
    choose: '请选择一个答案',
    chapter: '章节',
    essential: '基本模块',
    essentialSub: '完成这些模块，获得您的铜牌CA STAR身份',
    specializationSub: '专业化的模块',
    finishSilver: '完成这些模块，获得您的白银CA STAR身份',
    status: '当前的状态',
  },
  nav: {
    home: '主页',
    train: '火車',
    retain: '保留',
    directory: '目录',
    promote: '推廣',
    sell: '銷售',
    info: '信息',
    media: '媒体',
    favorites: '收藏夹',
    contact: '联络',
    reportCard: '报告卡',
    accountSettings: '账户设置',
    messages: '梦之星短消息',
    search: '搜索',
    showcases: '產品展示',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: '培训库',
    retain: '保留',
    subapps: '加州合作伙伴微型模块',
    maintrainings: '基础',
    subtrainings: '体验',
  },
  pageDescriptions: {
    train: '教育、参与并成为专家。',
    retain:
      '您保留专业知识和促进销售工作的首选资源。 使用此区域可以随时随地通过任何设备专业地回答产品问题，甚至作为即兴的销售演示。',
    promote: '易于访问“可分享的销售支援工具”和“联络我们”。',
    sell: '经过组织，全部媒体资产和销售支援工具都易于访问和分享。',
    favorites: '查看您个人最爱的内容',
    search: '浏览所有内容',
    subapps: '从合作伙伴处了解更多信息',
    maintrainings: '完成這些重要章節以獲得您的文憑！',
    subtrainings: '完成以下每個專門的體驗，就可以獲得一個徽章。',
  },
  general: {
    showcase: 'Showcases',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    back: '返回',
    close: '关闭',
    page: '页面',
    search: '搜索',
    logIn: '登录',
    logOut: '退出',
    viewItem: '查看',
    imageNotFound: '未找到图像',
    noResultsFor: '以下查询未找到结果：{query}',
    noFavorites: '您还没有添加任何内容到收藏夹。',
    noMessages: '您还没有收到任何短消息！',
    resultsFor: '针对以下查询的结果：{query}',
    showAll: '显示全部',
    connectionError: '连接错误',
    alreadyExists: '已存在',
    pageNotFound: '404 页面未找到！',
    oops: '啊哦……',
    overview: '返回概览',
    complete: '已完成课程！',
    share: '分享',
    destinations: '加州合作伙伴小培训',
    essentials: '加州基本信息',
    trainingLibrary: '培训库',
    message: '{count} 梦之星短消息',
    messagePlural: '{count} 梦之星短消息',
    badge: '徽章',
  },
  itemTypes: {
    image: '图像',
    brochure: '收集',
    layout: '布局',
    web: '网站',
    pdf: 'PDF',
    carousel: '收集',
  },
  questions: {
    dials: '旋转转盘以匹配答案',
    fitb: '填空',
    flip: '变更编号以匹配答案',
    multipleChoice: '选出正确答案',
    slider: '使用滚动条选出正确答案',
    map: '通过轻触地图上的正确位置回答问题',
    dropdown: '选择……',
    true: '真',
    false: '假',
  },
  cookies: {
    consent: '同意',
    optout: '选择退出',
    settings: '隐私设置',
    message:
      '您还没有将您的数据隐私偏好告知我们！没关系，但是，我们想要让您获得销售伙伴的最佳使用体验。',
    disabled: '看上去您禁用了 cookies。',
    use: '{appName} 需要使用 cookies 才能为您送上最佳体验。',
    details: 'Cookies 有什么用途？',
    enable: '在 {here} 查看如何启用您的 cookies。',
    here: '此处',
  },
  notLoggedIn: {
    super: '您还未登录',
    title: '您需要登录才能查看此内容',
    guest: '访客',
  },
  demo: {
    message: '本网站是最终产品的样本。当前还在开发中，并非完整的产品。',
    consent: '了解了！',
  },
  share: {
    header: '在您最爱的社交媒体上分享这一资源！',
    download: 'download',
  },
  breadCrumbs: {
    page: '页面',
  },
  onMobile: {
    header: '看起来您正在尝试从移动设备访问 {appName} App',
    body: '如想下载此项目，您只需要访问您的应用商店，并搜索 {appName} 或点击下方的一个按钮',
    benefits: {
      header: '您将会获得：',
      1: '可携带性',
      2: '无需 WiFi，在方便时即可随时随地展开培训',
      3: '在指尖玩转销售工具和资源',
    },
  },
  sharing: {
    twitter: '考虑把下一次度假的目的地定在加州……',
    imageEmailSubject: '加州梦之星，全心全意为您提供专属服务……度假妙想',
    imageEmailCopy: '花一分钟时间查看随附的加州梦之星度假内容……享受吧！',
    videoEmailSubject: '与您分享酷炫的加州梦之星度假妙想！',
    videoEmailCopy:
      '我认为您会喜欢这一则加州梦之星度假视频。点击下方的链接就可以观看啦。  享受吧！',
    infographicEmailSubject: '分享有关加州梦之星度假妙想的想法……',
    infographicEmailCopy:
      '我认为您会对这个内容感兴趣的，请花一分钟时间查看随附的内容吧。   马上回来！',
    copyURL: '複製鏈接',
    copied: '已復制',
  },
  newTrainingFlow: {
    tip: '提示：‘您可以通过完成 每一层中的模块来获得自己的身份。  梦想远大，通过完成所有模块来达到金牌CA STAR身份!',
    essentialModules: '基本模块',
    finishBronze: '完成这些模块，获得您的铜牌CA STAR身份',
    specializationModules: '专业化的模块',
    finishSilver: '完成这些模块，获得您的白银CA STAR身份',
    partnerModules: '合作伙伴模块',
    finishGold: '完成这些模块，获得您的金牌CA STAR身份',
    currentStatus: '当前的状态',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: '直到你达到 {rank} 排名！',
    outOf: '{points}  XP出局',
    pointsToRank: '{pointsToLevel}  需要排名的XP:  ({rank})',
  },
  points: {
    completed: '已完成 {completed} / {total}',
  },
  new: {
    achievements: '成就',
  },
  badgeView: {
    title: '培训成就',
    subtitle:
      '欢迎访问您的 “成就 ”仪表板，在这里您可以查看、跟踪和下载您的文凭和专业徽章。',
    badgeDisplayTitle: '金属成就状态',
    badgeAchievement: '您已达到{rank}状态！点击右侧图标查看并分享您的状态。',
    bronze: '青铜级',
    silver: '银级',
    gold: '金级',
    platinum: '白金级',
    complete: '完成',
    diploma: '证书',
    chapterBadges: '專業徽章',
    partnerBadges: '合作伙伴徽章',
  },
  badgeDisplay: {
    status: '訓練成就狀況',
  },
  search: {
    pages: '頁面',
    resources: '資源',
  },
};
